const MedialistList = {

    init(el, form) {

        if (!el.length || !form.length) {
            return;
        }

        this.form = form;
        this.view = el.find(".view");
        this.editButton = 'button.edit';

        this.inputEmail = this.form.find('input[name="email"');

        this.start();
        this.bind();
    },

    start() {
    },

    bind() {
        $(document).on("click", MedialistList.editButton, function (el) {
            const data = $(el.currentTarget).data();

            MedialistList.setFormData(data);
            MedialistList.blockChangeEmail($(el.currentTarget));
            MedialistList.form.parents().closest(".boxSwitcher.hidden").removeClass("hidden");

            return false;
        });

        $(document).on("reset", MedialistList.form, function (el) {
            $(".readonly").removeClass("readonly");
            MedialistList.inputEmail.prop("readonly", false);
        });
    },

    setFormData(data) {
        Object.keys(data).forEach(function (key, index) {
            let input = MedialistList.form.find("#" + key);

            input.val(data[key]);

            if (input.is("select")) {
                if (!data[key]) {
                    input.val();
                }
            }

            input.trigger("change");
        });
    },

    blockChangeEmail(element) {

        $(".readonly").removeClass("readonly");

        if ($(element).is(".deletable")) {
            $(this.inputEmail).prop("readonly", true).parents().closest('[component="Input"]').addClass("readonly");
        } else {
            $(this.inputEmail).prop("readonly", false);
        }
    }
}
export default MedialistList;